import React from 'react'
import { AccordionContainer } from '../../../../../../../../common/components/accordion/accordion.module'
import Table from '../../../../../../../../common/components/table'
import MobileViewTable from '../../../../../../../../common/components/mobile-view-table.component'

export default function ShipmentItemInfoComponent({ rowData, columnDefs }: any) {

  return (
    <>
      <AccordionContainer
        child={
          <MobileViewTable
            dataLength=""
            fetchMoreData=""
            hasMore=""
            columnData={columnDefs}
            rowData={rowData}
          />

        }
        expandedPanel="basicInfo"
        headerTitle="Shipment Item Info"
      />


    </>
  )
}